import { useEffect } from "react";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

export default function useSeo({ title, description, image, type = "website", jsonLd } = {}) {
  useEffect(() => {
    const full = title ? `${title} · NEXODUM` : "NEXODUM · Historias que nos conectan";
    document.title = full;
    setMeta("description", description || "NEXODUM, medio de comunicación independiente. Periodismo, actualidad, culturas, sociedad y mundo.");
    setMeta("og:title", full, "property");
    setMeta("og:description", description || "Historias que nos conectan.", "property");
    setMeta("og:type", type, "property");
    if (image) setMeta("og:image", image, "property");
    setMeta("twitter:card", "summary_large_image");

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => { if (script) document.head.removeChild(script); };
  }, [title, description, image, type, jsonLd]);
}
